import { Link } from "react-router-dom";

export const DISCLAIMER_TEXT =
  "This tool does not provide medical advice, diagnosis, or treatment. Information is for educational purposes only. Always consult a qualified healthcare provider before making decisions about tests, medications, or treatments. Our philosophy: the purpose of functional medicine and healthcare is to restore function within the body — not merely to address individual pain symptoms or diseases.";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="border-t border-slate-100 bg-surface-subtle mt-24">
      <div className="max-w-7xl mx-auto px-6 py-12 grid md:grid-cols-3 gap-10">
        <div>
          <div className="font-heading font-semibold text-lg text-ink-900">
            Healthchoices<span className="text-brand-blue">.health</span>
          </div>
          <p className="mt-3 text-sm text-ink-600 max-w-sm leading-relaxed">
            Turn your symptoms into a smart list of blood tests to discuss with your practitioner.
          </p>
        </div>
        <div className="md:col-span-2">
          <p
            data-testid="footer-disclaimer"
            className="text-xs leading-relaxed text-ink-500 bg-white rounded-2xl p-6 border border-slate-100"
          >
            {DISCLAIMER_TEXT}
          </p>
          <div className="mt-4 flex gap-6 text-xs text-ink-500">
            <Link to="/terms" data-testid="footer-terms">Terms</Link>
            <Link to="/privacy" data-testid="footer-privacy">Privacy</Link>
            <span>© {new Date().getFullYear()} Healthchoices.health</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
